import { createSlice } from '@reduxjs/toolkit';

import { LOADING_STATE } from '../constants/loadingState';

const dataExchangesSlice = createSlice({
  name: 'dataExchanges',

  initialState: {
    dataExchangeCompanies: [],
    dataExchangeCompaniesLoading: LOADING_STATE.NOT_LOADED,
    dataExchanges: [],
    dataExchangesLoading: LOADING_STATE.NOT_LOADED,
  },

  reducers: (create) => ({
    replaceDataExchangeCompanies: create.reducer((state, parameter) => {
      const { payload } = parameter;

      state.dataExchangeCompanies = [...payload];
      state.dataExchangeCompaniesLoading = LOADING_STATE.SUCCEEDED;
    }),

    replaceDataExchanges: create.reducer((state, parameter) => {
      const { payload } = parameter;

      state.dataExchanges = [...payload];
      state.dataExchangesLoading = LOADING_STATE.SUCCEEDED;
    }),

    setDataExchangeCompaniesLoading: create.reducer((state, parameter) => {
      const { payload } = parameter;

      state.dataExchangeCompaniesLoading = payload;
    }),

    setDataExchangesLoading: create.reducer((state, parameter) => {
      const { payload } = parameter;

      state.dataExchangesLoading = payload;
    }),
  }),
});

const { actions, reducer } = dataExchangesSlice;
export const {
  replaceDataExchangeCompanies,
  replaceDataExchanges,
  setDataExchangeCompaniesLoading,
  setDataExchangesLoading,
} = actions;
export default reducer;
